module.exports = __webpack_public_path__ + "assets/img/diy_active.5fafc51e.png";